export default __webpack_public_path__ + "FLU_lamping_flourescent-47e.svg";